/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HirerContractTemplate = {
  properties: {
    hirerId: {
      type: 'string',
    },
    contractTemplateId: {
      type: 'string',
    },
  },
} as const;
